/** Centralized bilingual labels for the admin dashboard. */
export const ADMIN_T = {
  ar: {
    brand: 'لوحة تحكم EBC',
    dashboard: 'نظرة عامة',
    news: 'إدارة الأخبار',
    certificates: 'الشهادات',
    services: 'مجالات عملنا',
    projects: 'المشاريع',
    partners: 'الشركاء',
    galleryPage: 'معرض الصور',
    clientLogos: 'شعارات العملاء',
    lists: 'الإحصاءات والقوائم',
    heroes: 'أقسام البطل',
    global: 'المحتوى العام',
    sectionCopy: 'عناوين الأقسام',
    strategicGoals: 'الأهداف الاستراتيجية',
    contactPage: 'صفحة تواصل معنا',
    company: 'من نحن',
    contact: 'الاتصال والشبكات (تذييل الصفحة)',
    media: 'مكتبة الوسائط',
    settings: 'الإعدادات',
    signOut: 'تسجيل الخروج',
    welcome: 'مرحباً',
    loginTitle: 'تسجيل دخول المسؤول',
    loginSubtitle: 'إدارة محتوى موقع شركة التوازن البيئي',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    signIn: 'دخول',
    signingIn: 'جارٍ الدخول…',
    languageSwitch: 'English',
    invalidCreds: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    total: 'الإجمالي',
    published: 'منشور',
    draft: 'مسودة',
    mediaFiles: 'ملفات الوسائط',
    recentNews: 'أحدث الأخبار',
    recentActivity: 'النشاط الأخير',
    noData: 'لا توجد بيانات',
    addArticle: 'مقال جديد',
    search: 'بحث…',
    allCategories: 'كل التصنيفات',
    allThemes: 'كل الثيمات',
    allStatuses: 'كل الحالات',
    actions: 'الإجراءات',
    edit: 'تعديل',
    delete: 'حذف',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    titleAr: 'العنوان (عربي)',
    titleEn: 'العنوان (إنجليزي)',
    excerptAr: 'الوصف المختصر (عربي)',
    excerptEn: 'الوصف المختصر (إنجليزي)',
    contentAr: 'المحتوى الكامل (عربي)',
    contentEn: 'المحتوى الكامل (إنجليزي)',
    featuredImage: 'الصورة الرئيسية',
    gallery: 'الصور الإضافية / المعرض',
    category: 'التصنيف',
    theme: 'الثيم البصري',
    tagAr: 'الوسم (عربي)',
    tagEn: 'الوسم (إنجليزي)',
    authorAr: 'الكاتب (عربي)',
    authorEn: 'الكاتب (إنجليزي)',
    pullQuoteAr: 'اقتباس بارز (عربي)',
    pullQuoteEn: 'اقتباس بارز (إنجليزي)',
    readMinutes: 'وقت القراءة (دقائق)',
    status: 'الحالة',
    publishDate: 'تاريخ النشر',
    saveDraft: 'حفظ كمسودة',
    publish: 'نشر',
    preview: 'معاينة',
    update: 'تحديث',
    back: 'رجوع',
    paragraphHint: 'فقرة واحدة في كل سطر',
    uploadFile: 'رفع ملف',
    copyUrl: 'نسخ الرابط',
    linkCopied: 'تم نسخ الرابط',
    fileSize: 'الحجم',
    uploadedBy: 'رفع بواسطة',
    uploadedAt: 'تاريخ الرفع',
    pickFromLibrary: 'اختيار من المكتبة',
    uploadOrPaste: 'ارفع ملفاً أو الصق رابطاً',
    chooseFile: 'اختر ملفاً',
    or: 'أو',
    pasteUrl: 'الصق رابط الصورة',
    add: 'إضافة',
    changePasswordTitle: 'تغيير كلمة المرور',
    oldPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    passwordsMismatch: 'كلمتا المرور غير متطابقتين',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح',
    save: 'حفظ',
    comingSoon: 'قريباً — هذا القسم تحت التطوير في المرحلة التالية.',
  },
  en: {
    brand: 'EBC Admin',
    dashboard: 'Overview',
    news: 'News',
    certificates: 'Certificates',
    services: 'Fields of Work',
    projects: 'Projects',
    partners: 'Partners',
    galleryPage: 'Gallery',
    clientLogos: 'Client Logos',
    lists: 'Stats & Lists',
    heroes: 'Page Heroes',
    global: 'Global Content',
    sectionCopy: 'Section Copy',
    strategicGoals: 'Strategic Goals',
    contactPage: 'Contact Us Page',
    company: 'Company',
    contact: 'Contact & Social (Footer)',
    media: 'Media Library',
    settings: 'Settings',
    signOut: 'Sign out',
    welcome: 'Welcome',
    loginTitle: 'Admin Sign In',
    loginSubtitle: 'Manage the Environmental Balance Company website',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signingIn: 'Signing in…',
    languageSwitch: 'العربية',
    invalidCreds: 'Email or password is incorrect',
    total: 'Total',
    published: 'Published',
    draft: 'Drafts',
    mediaFiles: 'Media files',
    recentNews: 'Recent news',
    recentActivity: 'Recent activity',
    noData: 'No data yet',
    addArticle: 'New article',
    search: 'Search…',
    allCategories: 'All categories',
    allThemes: 'All themes',
    allStatuses: 'All statuses',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete?',
    titleAr: 'Title (Arabic)',
    titleEn: 'Title (English)',
    excerptAr: 'Excerpt (Arabic)',
    excerptEn: 'Excerpt (English)',
    contentAr: 'Full content (Arabic)',
    contentEn: 'Full content (English)',
    featuredImage: 'Featured image',
    gallery: 'Gallery images',
    category: 'Category',
    theme: 'Visual theme',
    tagAr: 'Tag (Arabic)',
    tagEn: 'Tag (English)',
    authorAr: 'Author (Arabic)',
    authorEn: 'Author (English)',
    pullQuoteAr: 'Pull quote (Arabic)',
    pullQuoteEn: 'Pull quote (English)',
    readMinutes: 'Read time (minutes)',
    status: 'Status',
    publishDate: 'Publish date',
    saveDraft: 'Save draft',
    publish: 'Publish',
    preview: 'Preview',
    update: 'Update',
    back: 'Back',
    paragraphHint: 'One paragraph per line',
    uploadFile: 'Upload file',
    copyUrl: 'Copy URL',
    linkCopied: 'Link copied',
    fileSize: 'Size',
    uploadedBy: 'Uploaded by',
    uploadedAt: 'Uploaded',
    pickFromLibrary: 'Pick from library',
    uploadOrPaste: 'Upload a file or paste a URL',
    chooseFile: 'Choose file',
    or: 'or',
    pasteUrl: 'Paste image URL',
    add: 'Add',
    changePasswordTitle: 'Change password',
    oldPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    passwordsMismatch: 'Passwords do not match',
    passwordChanged: 'Password changed successfully',
    save: 'Save',
    comingSoon: 'Coming soon — this section is under development in the next phase.',
  },
};
